import { type FC } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

export type SaveChangesConfirmationDialogProps = {
  open: boolean;
  onSave: () => void;
  onCancel: () => void;
};

export const SaveChangesConfirmationDialog: FC<
  SaveChangesConfirmationDialogProps
> = ({ open, onSave, onCancel }) => (
  <Dialog open={open} maxWidth="xs" fullWidth>
    <DialogTitle>Save Changes</DialogTitle>
    <DialogContent>
      <Typography variant="body1">
        Save your changes to the lighting count entry before editing the fixture
        type?
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Cancel</Button>
      <Button onClick={onSave} variant="contained">
        Save & Continue
      </Button>
    </DialogActions>
  </Dialog>
);
